var $a151dd0df33d619b$exports = {};
$a151dd0df33d619b$exports = {
    "endTime": `Befejez\xe9s ideje`,
    "startTime": `Kezd\xe9s ideje`,
    "time": `Id\u{151}`
};


export {$a151dd0df33d619b$exports as default};
//# sourceMappingURL=hu-HU.module.js.map
